import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../store/auth'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import TransactionsView from '../views/TransactionsView.vue'
import TransactionDetailView from '../views/TransactionDetailView.vue'
import ReviewQueueView from '../views/ReviewQueueView.vue'
import MonarchTransactionsView from '../views/MonarchTransactionsView.vue'
import MonarchCategoriesView from '../views/MonarchCategoriesView.vue'
import SettingsView from '../views/SettingsView.vue'
import DismissedReceiptsView from '../views/DismissedReceiptsView.vue'
import ForwardingSetupView from '../views/ForwardingSetupView.vue'
import AuthCallback from '../views/AuthCallback.vue'
import JoinHouseholdView from '../views/JoinHouseholdView.vue'
import OnboardingView from '../views/OnboardingView.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: AuthCallback,
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: TransactionsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions/:id',
    name: 'TransactionDetail',
    component: TransactionDetailView,
    meta: { requiresAuth: true }
  },
  {
    path: '/review',
    name: 'ReviewQueue',
    component: ReviewQueueView,
    meta: { requiresAuth: true }
  },
  {
    path: '/monarch/transactions',
    name: 'MonarchTransactions',
    component: MonarchTransactionsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    name: 'Categories',
    component: MonarchCategoriesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: SettingsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/receipts/dismissed',
    name: 'DismissedReceipts',
    component: DismissedReceiptsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/forwarding/setup',
    name: 'ForwardingSetup',
    component: ForwardingSetupView,
    meta: { requiresAuth: true }
  },
  {
    path: '/join/:token',
    name: 'JoinHousehold',
    component: JoinHouseholdView,
    meta: { requiresAuth: false }
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: OnboardingView,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // Check if route requires authentication
  if (to.meta.requiresAuth) {
    // Check if user is authenticated
    if (!authStore.isAuthenticated) {
      // Try to restore auth from token
      await authStore.checkAuth()

      if (!authStore.isAuthenticated) {
        // Redirect to login
        next({ name: 'Login' })
        return
      }
    }

    // Check if user needs onboarding (skip for onboarding route itself)
    const onboardingComplete = localStorage.getItem('onboardingComplete')
    if (!onboardingComplete && to.name !== 'Onboarding' && to.name !== 'ForwardingSetup') {
      next({ name: 'Onboarding' })
      return
    }
  }

  // If already authenticated and trying to access login, redirect to dashboard
  if (to.name === 'Login' && authStore.isAuthenticated) {
    next({ name: 'Dashboard' })
    return
  }

  next()
})

export default router
